import React from 'react';
import {
  ItemPickerList,
  ItemPickerHeader,
  ItemPickerFooter,
  ItemPickerHeaderTitle,
  ItemPickerListContainer,
  LoadingWrapper,
  ItemPickerBackButton,
  ItemPickerSaveButton,
} from 'components/ItemPicker/styles';
import {
  ItemViewerName,
  ItemViewerWrapper,
} from 'components/ItemPicker/ItemViewer/styles';
import messages from './Messages';
import BubbleLoading from 'components/BubbleLoading';
import Icon from 'components/Icon';
import { LoadingIcon } from 'components/LoadingIcon/LoadingIcon';
import IconTypes from '../../../../../Icon/IconTypes';
import Badge from '../../../../../Badge';
import { gray } from '../../../../../../utils/style/colors';
import {
  IQuestionsView,
  QuestionTypes,
} from '../../../../../../store/survey/surveyTypes';
import Button from '../../../../../Button';
import { languageDirection } from '../../../../../../i18n';

interface IComponentProps {
  onSelectQuestions: (questionIds: number[]) => void;
  questions: IQuestionsView[];
  selectedQuestions: number[];
  onChangeView: () => void;
  onSaveQuestions: () => void;
  saving: boolean;
  showBackButton: boolean;
  currentSelected: number[];
  itemName: string;
  allowedQuestionTypes?: QuestionTypes[];
}

export function getQuestionIcon(type: QuestionTypes): IconTypes {
  switch (type) {
    case 'text':
      return 'align-center';
    case 'file':
      return 'file';
    case 'grid':
      return 'grid';
    case 'indicator':
      return 'bookmark';
    case 'multipleChoice':
      return 'check';
    case 'multipleAnswer':
      return 'menu';
  }
}
class QuestionPicker extends React.PureComponent<IComponentProps> {
  onSelectAnItem = (questionId: number) => () => {
    const pos = this.props.selectedQuestions.indexOf(questionId);
    const res = [...this.props.selectedQuestions];
    if (pos >= 0) res.splice(pos, 1);
    else res.push(questionId);
    this.props.onSelectQuestions(res);
  };

  addQuestionInBlulk = () => {
    const questionIdList = this.props.questions.reduce(
      (acc: number[], question: IQuestionsView) => {
        if (!this.props.currentSelected.includes(question.id))
          acc.push(question.id);
        return acc;
      },
      []
    );

    this.props.onSelectQuestions(questionIdList);
  };

  render() {
    const {
      onChangeView,
      onSaveQuestions,
      questions,
      saving, // TODO: remove saving state from parent
      selectedQuestions,
      showBackButton,
      currentSelected,
      allowedQuestionTypes,
    } = this.props;
    const loading = false;

    const dir = languageDirection() === 'rtl' ? 'right' : 'left';

    return (
      <ItemPickerListContainer>
        <ItemPickerHeader showBackButton={showBackButton}>
          {showBackButton && (
            <ItemPickerBackButton
              type="arrow-right"
              onClick={onChangeView}
              disabled={!!loading}
            />
          )}
          <ItemPickerHeaderTitle>
            {messages.questions(this.props.itemName)}
          </ItemPickerHeaderTitle>
        </ItemPickerHeader>
        {loading && (
          <LoadingWrapper>
            <BubbleLoading />
          </LoadingWrapper>
        )}
        <ItemPickerList loading={!!loading}>
          {(questions?.length ?? 0 > 0) ? (
            questions!
              .sort((a: IQuestionsView, b: IQuestionsView) => a.order - b.order)
              .map((question?: IQuestionsView) => {
                const disabled =
                  currentSelected.includes(question!.id || -1) ||
                  (allowedQuestionTypes &&
                    !allowedQuestionTypes.includes(question!.type));
                return (
                  <ItemViewerWrapper
                    key={question!.id}
                    onClick={
                      disabled
                        ? undefined
                        : this.onSelectAnItem(question!.id as number)
                    }
                    selected={selectedQuestions.includes(question!.id || -1)}
                    disabled={disabled}
                  >
                    <Icon type={getQuestionIcon(question!.type)} />
                    <ItemViewerName>{question?.title}</ItemViewerName>
                    {currentSelected.includes(question!.id || -1) && (
                      <Badge color={gray}>
                        <div
                          className="white-text"
                          style={{ color: 'var(--exact-white) !important' }}
                        >
                          {messages.added}
                        </div>
                      </Badge>
                    )}
                  </ItemViewerWrapper>
                );
              })
          ) : (
            <p style={{ alignSelf: 'center', textAlign: 'center' }}>
              {messages.thereIsNoItem}
            </p>
          )}
        </ItemPickerList>
        <ItemPickerFooter>
          <ItemPickerSaveButton
            onClick={onSaveQuestions}
            isActive={selectedQuestions.length > 0}
          >
            {messages.add(selectedQuestions.length)}
            {saving ? (
              // TODO: fix marginRight style
              <LoadingIcon
                customStyle={{
                  position: 'relative',
                  marginInlineStart: '0.5rem',
                }}
                color="white"
              />
            ) : (
              <Icon type="arrow-left" className={dir} />
            )}
          </ItemPickerSaveButton>
          <Button
            color={'blue'}
            onClick={this.addQuestionInBlulk}
            style={{ margin: '0 1rem', display: 'flex', gap: '5px' }}
          >
            <Icon type="check-circle" className={dir} />
            {messages.addAllQuestions}
          </Button>
        </ItemPickerFooter>
      </ItemPickerListContainer>
    );
  }
}

export default QuestionPicker;
